import { useState } from 'react';
import Layout from '@/components/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import PaymentSettings from '@/components/PaymentSettings';
import OrganizationSettings from '@/components/OrganizationSettings';
import { CreditCard, Building2, User } from 'lucide-react';

export default function Settings() {
  const [activeTab, setActiveTab] = useState('payment');

  return (
    <Layout>
      <div className="p-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Impostazioni</h1>
          <p className="text-gray-600 mb-8">Gestisci le impostazioni del tuo account e della tua organizzazione</p>

          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList className="grid w-full grid-cols-3 mb-8">
              <TabsTrigger value="payment" className="flex items-center gap-2">
                <CreditCard className="w-4 h-4" />
                Pagamenti
              </TabsTrigger>
              <TabsTrigger value="organization" className="flex items-center gap-2">
                <Building2 className="w-4 h-4" />
                Organizzazione
              </TabsTrigger>
              <TabsTrigger value="profile" className="flex items-center gap-2">
                <User className="w-4 h-4" />
                Profilo
              </TabsTrigger>
            </TabsList>

            <TabsContent value="payment">
              <PaymentSettings />
            </TabsContent>

            <TabsContent value="organization">
              <OrganizationSettings />
            </TabsContent>

            <TabsContent value="profile">
              <Card>
                <CardHeader>
                  <CardTitle>Profilo Utente</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600">
                    Gestione dati personali e password (da implementare)
                  </p>
                </CardContent>
              </Card>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </Layout>
  );
}
